<template>
  <div class="pt-2 px-4">
    <div class="d-flex">
      <div class="w-100">
        <h4>Form is</h4>
        <v-select
          v-model="selectedForm"
          :options="forms"
          label="label"
          value="value"
          :searchable="false"
          @input="fetchQuestionList()"
        ></v-select>
      </div>
      <div v-if="selectedForm" class="w-100 pl-3">
        <h4>Question is</h4>
        <v-select
          v-model="selectedQuestion"
          :options="questions"
          label="label"
          value="value"
          :searchable="false"
          @input="updateQuestions"
        ></v-select>
      </div>
    </div>
    <br />

    <div v-if="selectedQuestion" class="d-flex">
      <div class="w-100">
        <h4>Answer</h4>
        <v-select
          v-model="selectedOperator"
          :options="operators"
          label="label"
          value="value"
          :searchable="false"
          @input="updateQuestions"
        ></v-select>
      </div>
      <div class="w-100 pl-3">
        <h4>Value</h4>
        <template
          v-if="
            selectedQuestionType === 'radio' ||
            selectedQuestionType === 'checkbox' ||
            selectedQuestionType === 'select'
          "
        >
          <template
            v-if="
              selectedOperatorValue === '=' || selectedOperatorValue === '!='
            "
          >
            <v-select
              v-model="selectedAnswers"
              :options="selectedQuestionOptions"
              :searchable="false"
              @input="updateQuestions"
            ></v-select>
          </template>
          <template
            v-else-if="
              selectedOperatorValue === 'in' ||
              selectedOperatorValue === 'not in'
            "
          >
            <v-select
              v-model="selectedAnswers"
              :options="selectedQuestionOptions"
              multiple
              :searchable="false"
              @input="updateQuestions"
            ></v-select>
          </template>
          <template v-else>
            <vs-input
              v-model="textAnswer"
              class="w-100"
              :placeholder="`Answer`"
              block
              @input="updateQuestions"
            ></vs-input>
            <!-- <input v-model="textAnswer" type="text" /> -->
          </template>
        </template>
        <template v-else>
          <vs-input
            v-model="textAnswer"
            class="w-100"
            :placeholder="`Answer`"
            block
            @input="updateQuestions"
          ></vs-input>
          <!-- <input v-model="textAnswer" type="text" /> -->
        </template>
      </div>
    </div>

    <br />
  </div>
</template>

<script>
import vSelect from "vue-select";
import Service from "@/services";
export default {
  props: {
    forms: {
      type: Array,
      default: () => [],
    },
    conditions: {
      type: Object,
    },
    onChange: {
      type: Function,
    },
  },
  components: {
    vSelect,
  },
  data() {
    return {
      isFirstFetch: true,
      questions: [],
      operators: [
        {
          label: "is",
          value: "=",
        },
        {
          label: "is not",
          value: "!=",
        },
        {
          label: "is in",
          value: "in",
        },
        {
          label: "is not in",
          value: "not in",
        },
        {
          label: "greater than",
          value: ">",
        },
        {
          label: "less than",
          value: "<",
        },
        {
          label: "greater than or equal to",
          value: ">=",
        },
        {
          label: "less than or equal to",
          value: "<=",
        },
      ],
      selectedForm: null,
      selectedQuestion: null,
      selectedOperator: null,
      selectedAnswer: null,
      selectedAnswers: [],
      textAnswer: null,
    };
  },
  watch: {
    conditions() {
      this.reverveGenerateConditionsArray();
    },
  },
  mounted() {
    this.reverveGenerateConditionsArray();
  },
  computed: {
    selectedQuestionType() {
      if (!this.selectedQuestion) return false;
      const selectedQuestion = this.questions.find(
        (question) => question.value === this.selectedQuestion.value
      );
      return selectedQuestion ? selectedQuestion.question_type : null;
    },
    selectedQuestionOptions() {
      if (!this.selectedQuestion) return [];
      const selectedQuestion = this.questions.find(
        (question) => question.value === this.selectedQuestion.value
      );
      return (selectedQuestion ? selectedQuestion.options : []).map(
        (option) => option.value
      );
    },
    selectedOperatorValue() {
      if (!this.selectedOperator) return "";
      return this.selectedOperator.value;
    },
  },
  methods: {
    fetchQuestionList(callback) {
      const form_uuid = this.selectedForm.value;
      this.$vs.loading();
      let data = {
        e: this.$route.query.e,
        s: this.$route.query.s,
        perPage: 100,
        form_uuid: form_uuid,
      };

      let params = Object.keys(data)
        .map((key) => key + "=" + data[key])
        .join("&");

      Service.Question.getQuestionsByUUID(params)
        .then((res) => {
          this.questions = res.data.rows.map((item) => {
            // let max = null;
            // if (item.validations.length > 0) {
            //   item.validations.map((valid) => {
            //     if (valid.rule == "max") {
            //       max = valid.value;
            //     }
            //   });
            // }
            const mapped_item = {
              label: item.question_title,
              value: item.question_uuid,
              question_type: item.question_type,
            };
            if (
              item.question_type == "checkbox" ||
              item.question_type == "radio" ||
              item.question_type == "select"
            ) {
              mapped_item.options = item.options_json.map
                ? item.options_json.map((item) => {
                    return {
                      value: item.value,
                      label: item.text,
                    };
                  })
                : [];
            }
            return mapped_item;
          });
          this.questions = JSON.parse(JSON.stringify(this.questions));
          if (callback) {
            callback();
          }
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    async updateQuestions() {
      // try {
      //   // Make an API call to fetch questions based on the selected form ID
      //   const response = await fetch(`/api/questions?form_id=${this.selectedForm}`);
      //   const data = await response.json();
      //   this.questions = data.questions;
      // } catch (error) {
      //   console.error('Error fetching questions:', error);
      // }
      this.useGeneratedConditionsArray();
    },
    reverveGenerateConditionsArray() {
      if (
        !this.isFirstFetch ||
        !this.conditions ||
        !this.conditions.conditions ||
        this.conditions.conditions.length != 3
      ) {
        return;
      }
      this.selectedForm = this.forms.find((item) => {
        return item.value == this.conditions.conditions[0].value;
      });
      this.fetchQuestionList(() => {
        this.selectedQuestion = this.questions.find(
          (q) => q.value == this.conditions.conditions[1].value
        );

        this.selectedOperator = this.operators.find((o) => {
          return (
            o.value == this.conditions.conditions[2].operator ||
            o.label == this.conditions.conditions[2].operator
          );
        });
        if (
          this.selectedQuestionType === "radio" ||
          this.selectedQuestionType === "checkbox" ||
          this.selectedQuestionType === "select"
        ) {
          this.selectedAnswers = Array.isArray(
            this.conditions.conditions[2].value
          )
            ? this.conditions.conditions[2].value.map((qv) =>
                this.selectedQuestionOptions.find((qo) => qo == qv)
              )
            : this.selectedQuestionOptions.find((qo) => {
                return qo == this.conditions.conditions[2].value;
              });
        } else {
          this.textAnswer = this.conditions.conditions[2].value;
        }
      });
      this.isFirstFetch = false;
    },
    generateConditionsArray() {
      const conditionsArray = [];

      // Add form condition
      if (this.selectedForm) {
        conditionsArray.push({
          field: "form",
          operator: "=",
          value: this.selectedForm.value,
        });
      }

      // Add question condition
      if (this.selectedQuestion) {
        conditionsArray.push({
          field: "question",
          operator: "=",
          value: this.selectedQuestion.value,
        });
      }

      if (this.selectedOperator) {
        let value;
        if (
          this.selectedQuestionType === "radio" ||
          this.selectedQuestionType === "checkbox" ||
          this.selectedQuestionType === "select"
        ) {
          value = Array.isArray(this.selectedAnswers)
            ? this.selectedAnswers.map((item) => item.value || item)
            : (this.selectedAnswers.value || this.selectedAnswers);
            console.log('value', value)
        } else {
          value = this.textAnswer;
        }

        conditionsArray.push({
          field: "answer",
          operator: this.selectedOperator.value,
          value: value,
        });
      }

      // Example: Add more conditions based on other component inputs

      return {
        logic_between_conditions: "AND", // You can customize this based on your requirement
        conditions: conditionsArray,
      };
    },

    // ... existing methods

    // Example: You can call this method when you need to use the generated array
    useGeneratedConditionsArray() {
      const generatedConditions = this.generateConditionsArray();
      this.$emit("update:conditions", generatedConditions);
      if (this.onChange) {
        this.onChange(generatedConditions);
      }
      // You can use the generated array as needed
    },
  },
};
</script>

<style scoped>
/* Your component styles here */
</style>
